<template>
  <div class="adjust-params-container">
    <el-form
      :inline="true"
      label-width="auto"
      size="mini"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.6)"
    >
      <el-card>
        <span class="card-header-pointer" slot="header" @click="openDeveloper">
          {{ $t('基本参数') }}
        </span>
        <item
          :item-name="$t('设备号')"
          label-width="max-content"
          display-type="input"
          :disabled="true"
          :value="sn"
        ></item>
        <item
          :item-name="$t('设备类型') + ':'"
          label-width="max-content"
          display-type="input"
          :disabled="true"
          :value="deviceType"
        ></item>
        <item
          :item-name="$t('场景') + ':'"
          label-width="max-content"
          display-type="radio"
          item-type="any"
          v-model="model.sceneCurrent"
          :item-list="sceneList"
        ></item>
        <item
          style="display: block; margin-bottom: 0"
          :item-name="$t('屏蔽') + ':'"
          label-width="max-content"
          :display="developer"
          display-type="radio"
          item-type="any"
          v-model="model.preventFlag"
          :item-list="preventionList"
        ></item>
      </el-card>
      <el-row>
        <el-col :span="24 / params.length" v-for="block in params" :key="block.paramSceneCode">
          <el-card :header="$t(block.paramSceneName)">
            <div class="item-container">
              <item
                v-for="item in block.data"
                :key="item.id"
                v-bind="item"
                v-model="item.value"
              ></item>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import Item from './item.vue';
import { preventionList } from './utils/dict';

export default {
  components: {
    Item
  },
  inject: ['params', 'model', 'sn', 'deviceType'],
  props: {
    sceneList: Array,
    loading: Boolean
  },
  data() {
    return {
      i18nPath: 'component.deviceParamDialog',
      count: 1,
      developer: false,
      preventionList,
      timer: null
    };
  },
  methods: {
    /** 清除定时器 */
    clearTimer() {
      if (this.timer) clearTimeout(this.timer);
    },
    /** 8次连点 打开开发者模式 */
    openDeveloper() {
      this.count++;
      if (this.count >= 8) this.developer = true;
      this.clearTimer();
      this.timer = setTimeout(() => {
        this.count = 1;
        this.clearTimer();
      }, 1500);
    }
  }
};
</script>

<style lang="scss">
.adjust-params-container {
  overflow: hidden;
  .item-container {
    min-height: 40vh;
    .el-form-item {
      min-width: 60%;
      // .el-input {
      //   width: 200px;
      // }
    }
  }
  .el-row {
    overflow-y: scroll;
    margin-right: -18px;
    max-height: 52vh;
    border-right: 1px solid #1c3755;
    border-bottom: 1px solid #1c3755;
  }

  .card-header-pointer {
    user-select: none;
    cursor: pointer;
  }
}
</style>
